module.exports = __webpack_public_path__ + "img/slide-03.67023576.jpg";